<template>
  <div class="videos-listing-wrapper">
    <div
      class="common-video-wrapper col-xs-12 col-sm-12 col-md-4"
      v-for="(item, index) in videos"
    >
      <figure class="thumbnail">
        <video-embed
          :src="item.videoUrl"
          sandbox="allow-scripts allow-same-origin allow-presentation"
        ></video-embed>
        <a>
          <figcaption>{{ item.videoDesc }}</figcaption>
        </a>
      </figure>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    videos: {
      type: Array,
      default: () => ([])
    },
    imageUrl: {
      type: String,
      default: 'videoUrl'
    },
    imageLabel: {
      type: String,
      default: 'videoDesc'
    },
  }
}
</script>

<style lang="sass" scoped>
  .videos-listing-wrapper
    width: 100%
    .common-video-wrapper
      figure
        padding: 10px
    figcaption
      font-size: 16px
      font-weight: 700
      margin: 20px 10px
      height: 2rem
</style>
